export default __webpack_public_path__ + "static/media/004.dd5128a9.jpg";